// import core libraries
import Vue from 'vue';
import Vuex from 'vuex';
import VueRouter from 'vue-router';
import upperFirst from 'lodash/upperFirst';
import camelCase from 'lodash/camelCase';
import BootstrapVue from "bootstrap-vue";

// import CSS dependencies
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
import 'leaflet/dist/leaflet.css';

// import custom components used within router
import Landing from './views/Landing.vue';
import Model from './views/Model.vue';

// import raw data object
import CEAModel from './assets/models/CEA.js';

// initialize CEAModel
CEAModel.dataModel = CEAModel.createModel();
CEAModel.updateModel(true);

// import main app component
import App from './App.vue';

// use core library dependencies
Vue.use(BootstrapVue);
Vue.use(VueRouter);
Vue.use(Vuex);

// define router
const router = new VueRouter({
  routes: [
    {
      path: '/',
      name: 'Landing',
      components: {main: Landing, sideBar:""}
    },
    {
      path: '/Model',
      name: 'Model',
      components: {main: Model, sideBar:""}
    }
  ]
});

// define app data store
const store = new Vuex.Store({
  state: {
    CEAModel: CEAModel,
    includeIndirect: false
  },
  mutations: {
    setHorizon: (state, horizon) => {
      state.CEAModel.timeHorizon = horizon;
      state.CEAModel.updateModel(state.includeIndirect);
    },
    setCost: (state, cost) => {
      state.CEAModel.costDiscount = cost;
      state.CEAModel.updateModel(state.includeIndirect);
    },
    setEffectCost: (state, effect) => {
      state.CEAModel.effectDiscount = effect;
      state.CEAModel.updateModel(state.includeIndirect);
    },
    setExclude: (state, exclude) => {
      if(exclude){
        state.includeIndirect = false;
      } else {
        state.includeIndirect = true;
      }
      state.CEAModel.updateModel(state.includeIndirect);
    }
  }, 
  getters: {
    getCEAModel: (state) => {
      return state.CEAModel;
    }
  }
})

// initialize main application
new Vue({
  store,
  el: '#app',
  router,
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js